import type { I18nAdapter } from '@eye-able/ui';
import type { i18n as I18nInstance } from 'i18next';
import i18n from '@/i18n';
import { I18N_EVENTS } from '@/i18n/events';

export function createI18nAdapter(instance: I18nInstance): I18nAdapter {
  return {
    t: instance.t.bind(instance),
    getResolvedLanguage: () => instance.resolvedLanguage || 'en',
    subscribe: (onStoreChange) => {
      const handleChange = () => {
        onStoreChange();
      };

      I18N_EVENTS.forEach((event) => {
        instance.on(event, handleChange);
      });

      return () => {
        I18N_EVENTS.forEach((event) => {
          instance.off(event, handleChange);
        });
      };
    },
  };
}

export const dashboardI18nAdapter = createI18nAdapter(i18n);
